import { render, staticRenderFns } from "./ModalNps.vue?vue&type=template&id=2d62f058&scoped=true"
import script from "./ModalNps.vue?vue&type=script&lang=js"
export * from "./ModalNps.vue?vue&type=script&lang=js"
import style0 from "./ModalNps.vue?vue&type=style&index=0&id=2d62f058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62f058",
  null
  
)

export default component.exports